/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type VerifyOtpMutationVariables = {|
  mobileNumber: string,
  otp: string,
|};
export type VerifyOtpMutationResponse = {|
  +verifyOtp: ?{|
    +token: ?string,
    +refreshToken: ?string,
    +message: ?string,
    +user: ?{|
      +id: string,
      +email: ?string,
      +username: ?string,
      +mobileNumber: string,
      +firstName: string,
      +lastName: ?string,
      +isActive: boolean,
    |},
  |}
|};
export type VerifyOtpMutation = {|
  variables: VerifyOtpMutationVariables,
  response: VerifyOtpMutationResponse,
|};
*/


/*
mutation VerifyOtpMutation(
  $mobileNumber: String!
  $otp: String!
) {
  verifyOtp(mobileNumber: $mobileNumber, otp: $otp) {
    token
    refreshToken
    message
    user {
      id
      email
      username
      mobileNumber
      firstName
      lastName
      isActive
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mobileNumber"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "otp"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mobileNumber",
        "variableName": "mobileNumber"
      },
      {
        "kind": "Variable",
        "name": "otp",
        "variableName": "otp"
      }
    ],
    "concreteType": "VerifyOTP",
    "kind": "LinkedField",
    "name": "verifyOtp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mobileNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VerifyOtpMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VerifyOtpMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2770003d43273d16629d0e701914766f",
    "id": null,
    "metadata": {},
    "name": "VerifyOtpMutation",
    "operationKind": "mutation",
    "text": "mutation VerifyOtpMutation(\n  $mobileNumber: String!\n  $otp: String!\n) {\n  verifyOtp(mobileNumber: $mobileNumber, otp: $otp) {\n    token\n    refreshToken\n    message\n    user {\n      id\n      email\n      username\n      mobileNumber\n      firstName\n      lastName\n      isActive\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5ab8cb0f006f63af718d557051b62557';

module.exports = node;
